/* eslint-disable @typescript-eslint/no-explicit-any */
import { rgba } from 'polished';
import styled, { css } from 'styled-components';
import { palette, theme } from 'styled-tools';
import { minWidth } from '../../utils/mediaQueries';
import { fontFamily, fontSize, FontSizes, fontWeight } from '../../utils/typography';
import { Wrapper as LoaderWrapper } from '../Loader/styles';
import { ButtonSizes, FocusRingVariants } from './types';
function getPadding(size, hasIconAndText) {
    switch (size) {
        case ButtonSizes.Sm:
            return css `
				padding: ${2 / 3}rem ${8 / 9}rem;
				${hasIconAndText ? 'padding-left: 1rem;' : ''}
			`;
        case ButtonSizes.Md:
            return css `
				padding: ${3 / 4}rem ${10 / 9}rem;
				${hasIconAndText ? `padding-left: ${67 / 54}rem;` : ''}

				${minWidth('mobileLarge')} {
					padding-top: ${7 / 8}rem;
					padding-bottom: ${7 / 8}rem;
				}
			`;
        case ButtonSizes.Lg:
            return css `
				padding: 1rem ${4 / 3}rem;
				${hasIconAndText ? `padding-left: ${79 / 54}rem;` : ''}
			`;
    }
}
export const Wrapper = styled.button `
	align-items: center;
	${(props) => 
// eslint-disable-next-line no-nested-ternary
props.$isDisabled
    ? `background: ${palette('buttonDisabledBg')(props)}`
    : props.$backgroundColor
        ? `background: ${palette(props.$backgroundColor)(props)}`
        : ''};
	border-radius: ${theme('buttons.borderRadius')};
	border: ${p => (p.$borderColor ? `1px ${palette(p.$borderColor)(p)} solid` : 'none')};
	box-shadow: ${(props) => (props.$isDisabled || props.$hideShadow ? null : theme('buttons.shadow'))};
	color: ${(props) => 
// eslint-disable-next-line no-nested-ternary
props.$isDisabled
    ? palette('buttonDisabledText')
    : props.$textColor
        ? palette(props.$textColor)
        : palette('buttonPrimaryText')};
	display: inline-flex;
	${fontFamily};
	${props => (props.$size === ButtonSizes.Sm ? fontSize(FontSizes.sm) : fontSize(FontSizes.base))};
	${props => fontWeight(props.$fontWeight)}
	line-height: ${props => (props.$size === ButtonSizes.Sm ? '24px' : '28px')};
	justify-content: ${p => (p.$contentAlignment === 'left' ? 'flex-start' : 'center')};
	position: relative;
	transition: ${theme('animation.transition')};
	z-index: 0;
	cursor: ${(props) => (props.$isDisabled || props.$isLoading ? 'initial' : 'pointer')};
	${props => (props.$fullWidth ? 'width: 100%' : '')};
	outline: none;
	text-decoration: none;

	${minWidth('desktop')} {
		max-width: ${p => { var _a; return (_a = p.$maxWidth) !== null && _a !== void 0 ? _a : 'none'; }};
	}

	min-height: ${theme('buttons.minHeight')};
	min-width: 48px;

	${props => getPadding(props.$size, props.$hasIconAndText)};

	&:after {
		content: '';
		display: block;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		border: ${theme('buttons.focusRingWidth')} solid
			${p => p.$focusRingVariant === FocusRingVariants.Dark
    ? palette('focusRingDark')
    : palette('focusRingLight')};
		border-radius: ${theme('buttons.borderRadius')};
		transition: margin ${theme('animation.transition')}, opacity ${theme('animation.transition')};
		margin: ${p => (p.$isFocusVisible ? p.theme.buttons.focusRingDistance : '0;')};
		opacity: ${p => (p.$isFocusVisible ? '1' : '0')};
		box-shadow: ${(props) => (props.$hideShadow ? null : theme('buttons.focusShadow'))};
	}

	&:before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: ${theme('buttons.hoverBackground')};
		box-shadow: ${(props) => (props.$hideShadow ? null : theme('buttons.hoverShadow'))};
		border-radius: ${theme('buttons.borderRadius')};
		opacity: ${p => (p.$isFocusVisible ? '1' : '0')};
		transition: ${theme('animation.transition')};
		z-index: -1;
	}

	${(props) => props.$isDisabled || props.$isLoading
    ? ''
    : `
  ${minWidth('desktop')} {
    &:hover {
      &:before {
        opacity: 1;
      }
    }
  }
  `}

	${(props) => props.$isDisabled || props.$isLoading
    ? null
    : css `
					&:active {
						box-shadow: ${props.$hideShadow ? null : theme('buttons.pressedBorderShadow')};
						text-shadow: ${props.$hideShadow ? null : theme('buttons.pressedTextShadow')};

						&:before {
							box-shadow: ${props.$hideShadow ? null : theme('buttons.pressedInnerShadow')};
							opacity: 1;
						}
					}
			  `}

  ${LoaderWrapper} {
		position: absolute;
		height: 1.4rem;
	}

	${props => (props.$isLoading ? 'color: transparent' : null)};
`;
export const ButtonIcon = styled.div `
	height: 20px;
	width: 20px;

	svg {
		width: 20px;
		height: 20px;
		path {
			fill: ${(props) => {
    const resolvedColor = palette(props.$color)(props) || props.$color;
    return props.$isDisabled ? rgba(resolvedColor, 0.5) : resolvedColor;
}};
		}
	}

	${props => (!props.$iconOnly ? 'margin-right: 10px;' : '')}
	${props => props.$size !== ButtonSizes.Sm
    ? css `
					${minWidth('desktop')} {
						width: 26px;
						height: 26px;

						svg {
							width: 26px;
							height: 26px;
						}
					}
			  `
    : ''}
	${props => props.$size !== ButtonSizes.Sm && !props.$iconOnly
    ? css `
					${minWidth('desktop')} {
						margin-right: 15px;
					}
			  `
    : ''};
`;
//# sourceMappingURL=styles.js.map